import { render, staticRenderFns } from "./ChartInventoryStatusCards.vue?vue&type=template&id=6686e847"
import script from "./ChartInventoryStatusCards.vue?vue&type=script&lang=js"
export * from "./ChartInventoryStatusCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports